import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TextField, Typography, Chip, Box, Stack, Button } from '@mui/material';

import { inboxStatus } from 'venuescanner-js/constants/thread';
import inboxService from 'venuescanner-js/react/components/Inbox/services/inboxService';
import { ViewContext } from 'venuescanner-js/react/components/Inbox/context/ViewContext';
import declineReasons from 'venuescanner-js/react/components/Inbox/models/decline-reasons';
import reasons from 'venuescanner-js/constants/decline-reasons.js';
import { isHost, isOrganiser } from 'venuescanner-js/constants/user_type';
import EnquiryCtas from '../EnquiryCtas';
import InputLabel from '../InputLabel';

const EnquiryDecline = ({ thread, onSubmit, onCancel }) => {
  const { can } = thread;
  const { activeThreadStatus } = useContext(ViewContext);
  const [reasonSelected, setReasonSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessageValue] = useState('');
  const history = useHistory();
  const currPath = history.location.pathname;

  const handleReasonSelected = reason => {
    setReasonSelected(reasonSelected === reason.value ? false : reason.value);
  };

  const handleSubmit = () => {
    setLoading(true);

    inboxService[can.CANCEL ? 'cancelThread' : 'declineThread']({
      _id: thread._id,
      offer: thread.cumulativeOffer,
      message,
      attachments: [],
      reason: reasonSelected,
    }).then(() => {
      history.push(currPath);
    });

    if (isOrganiser(thread)) {
      onSubmit();
    }

    if (isHost(thread)) {
      const isNoteworthyReason = [
        reasons.PRICE,
        reasons.AVAILABILITY,
        reasons.SUITABILITY,
      ].includes(reasonSelected);
      onSubmit(isNoteworthyReason ? reasonSelected : null);
    }
  };

  const enquiryDeclineList = declineReasons(thread).map(
    (reason, index) =>
      reason !== null && (
        <Chip
          sx={{ mr: 1, mb: 1 }}
          variant={reasonSelected === reason.value ? 'filled' : 'outlined'}
          key={reason.value + index}
          label={reason.label}
          color={reasonSelected === reason.value ? 'primary' : undefined}
          onClick={() => handleReasonSelected(reason)}
        />
      ),
  );

  return (
    <Box
      component='section'
      className='enquiry-decline'
      sx={{ background: '#fff' }}>
      {loading ? (
        <span className='loading' />
      ) : (
        <>
          <Typography
            variant='body1'
            sx={{ fontSize: 18, lineHeight: 1.22, fontWeight: 600, mb: 1.5 }}>
            {activeThreadStatus === inboxStatus.BOOKED
              ? 'Cancel Booking'
              : 'Close Enquiry'}
          </Typography>
          <Stack
            className='enquiry-info'
            spacing={2}
            direction='column'
            sx={{ mb: 1.5 }}>
            <Typography
              variant='body1'
              sx={{ fontSize: 16, color: '#000', lineHeight: 1.3 }}>
              Select a reason for closing the enquiry
            </Typography>
            <Box sx={{ mb: 2 }}>{enquiryDeclineList}</Box>
          </Stack>
          {reasonSelected && (
            <Stack
              className='enquiry-info'
              spacing={2}
              direction='column'
              sx={{ pb: 2 }}>
              <InputLabel name='message' label='Message'/>
              <TextField
                multiline
                sx={{
                  '& .MuiInputBase-root': {
                    background: '#fff',
                    padding: '8px 10px',
                    fontSize: 12,
                    lineHeight: 1.33,
                    '&:placeholder': {
                      color: '#969696',
                    },
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: 0,
                  },
                  '& .MuiOutlinedInput-notchedOutline': {
                    top: -8,
                  },
                }}
                fullWidth
                rows={5}
                variant='outlined'
                id='message'
                name='message'
                value={message}
                onChange={e => setMessageValue(e.target.value)}
                placeholder='Type your message here'
              />
            </Stack>
          )}
          <EnquiryCtas sx={{ mt: 'auto' }}>
            <Button
              disabled={!reasonSelected}
              fullWidth
              color='primary'
              variant='contained'
              size='medium-large'
              onClick={handleSubmit}>
              Submit
            </Button>
            <Button
              fullWidth
              variant='outlined'
              color='primary'
              size='medium-large'
              onClick={onCancel}>
              Cancel
            </Button>
          </EnquiryCtas>
        </>
      )}
    </Box>
  );
};

export default EnquiryDecline;
